module.exports = __webpack_public_path__ + "static/BentoBox-8add4613b1772f812c97b98af0c540c6.jpg";